function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M81.619 21.049c2.116 0 4.42.703 6.551 2.834 5.214 5.214 2.066 15.74-7.118 15.74-1.862 0-3.971-.432-6.31-1.429-3.249 6.576-14.157 30.625-14.157 30.625s-4.336-1.337-8.053-1.337c-1.858 0-3.561.334-4.49 1.337-.995 1.074-3.812 4.447-3.812 4.447l-9.961-6.764c3.566-3.566-1.476-10.211-1.476-10.211l41.319-32.584s3.396-2.658 7.507-2.658m.001-6c-6.008 0-10.692 3.531-11.206 3.933L29.078 51.58a6 6 0 00-1.064 8.338c.643.87 1.288 2.184 1.477 2.956a6 6 0 001.408 8.592l9.961 6.764a5.979 5.979 0 003.367 1.036 5.989 5.989 0 004.608-2.154c.834-.998 2.208-2.625 3.064-3.605a7.15 7.15 0 01.633-.026c2.272 0 5.315.775 6.295 1.074a6.008 6.008 0 007.222-3.259c.09-.199 7.575-16.696 11.914-25.93 1.046.17 2.077.256 3.09.256 6.489 0 12.017-3.616 14.428-9.437 2.398-5.789 1.194-12.284-3.068-16.545-3.004-3.003-6.736-4.591-10.793-4.591z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M31.354 94.205a3 3 0 01-2.167-5.074L43.59 74.088a3 3 0 014.334 4.148L33.521 93.279a2.983 2.983 0 01-2.167.926zM9.316 89.641a3 3 0 01-2.066-5.177L30.1 62.8a3 3 0 114.129 4.353L11.38 88.817a2.987 2.987 0 01-2.064.824z"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 66.642,
  cy: 14.618,
  r: 5.823
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M61.9 9.096a.91.91 0 00-.098 1.283l3.972 4.625a.91.91 0 001.381-1.185l-3.972-4.625a.908.908 0 00-1.283-.098zM68.835 17.172c-.953.818-1.46 1.791-1.133 2.172l3.051 3.371c.328.381 3.779-2.584 3.451-2.965l-3.051-3.371c-.327-.381-1.365-.026-2.318.793z"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 53.773,
  cy: 24.935,
  r: 5.823
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M49.03 19.414a.91.91 0 00-.098 1.283l3.972 4.625a.91.91 0 001.283.096.907.907 0 00.097-1.281l-3.971-4.625a.91.91 0 00-1.283-.098zM55.966 27.49c-.953.818-1.46 1.791-1.133 2.172l3.051 3.371c.327.381 3.778-2.584 3.451-2.965l-3.051-3.371c-.328-.381-1.365-.025-2.318.793z"
});

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 40.903,
  cy: 35.254,
  r: 5.823
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.161 29.732a.91.91 0 00-.098 1.283l3.972 4.623a.906.906 0 001.282.098.908.908 0 00.098-1.283l-3.972-4.623a.908.908 0 00-1.282-.098zM43.097 37.806c-.953.82-1.461 1.791-1.133 2.174l3.051 3.371c.327.381 3.778-2.584 3.451-2.965l-3.052-3.371c-.327-.38-1.365-.027-2.317.791z"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 28.034,
  cy: 45.572,
  r: 5.823
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.291 40.051a.91.91 0 00-.097 1.283l3.972 4.623a.91.91 0 101.38-1.185l-3.972-4.623a.906.906 0 00-1.283-.098zM30.227 48.125c-.953.818-1.46 1.791-1.133 2.174l3.052 3.369c.327.383 3.778-2.582 3.451-2.963l-3.052-3.371c-.327-.381-1.365-.028-2.318.791z"
}));

function SvgBass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

export default SvgBass;